import { OverlayTrigger, Tooltip } from "@rio-cloud/rio-uikit";
import { BudgetColumn } from "../types";

interface KanbanColumnHeaderProps {
  column: { key: BudgetColumn; label: string };
  isMobile: boolean;
}

const KanbanColumnHeader = ({ column, isMobile }: KanbanColumnHeaderProps) => {
  return (
    <div className={`flex-1 px-0 ${isMobile ? "mb-4" : ""}`}>
      <div className={`bg-[#C7D1D9] dark:bg-neutral-800 ${isMobile ? "px-3 py-2" : "px-4 py-3"} flex justify-between items-center`}>
        <h3 className={`${isMobile ? "text-size-12" : "text-size-14"} font-semibold text-gray-900 dark:text-neutral-100 m-0 uppercase`}>
          {column.label}
        </h3>
        {!isMobile && (
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-${column.key}`} allowOnTouch>
                <div className="flex flex-col p-2.5 gap-6 max-w-[200px]">
                  <h3 className="text-size-14 font-bold">{column.label}</h3>
                </div>
              </Tooltip>
            }
          >
            <span className="cursor-pointer rioglyph rioglyph-info-circle text-gray-500 dark:text-neutral-400" style={{ fontSize: "18px" }} />
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
};

export default KanbanColumnHeader;
